import { BodyLink } from '@jouzen/ecom-components/v3/BodyLink';
import { useLocale } from 'next-intl';

import RichText from '@/app/components/RichText';
import getLocalePartialUrl from '@/utils/getLocalePartialUrl';

const CurrentTermsAndConditionsLink = () => {
  const localePath = getLocalePartialUrl(useLocale());

  return (
    <div className="mt-4 mb-8" data-cy="current-terms-and-conditions-link">
      <BodyLink href={`${localePath}terms-and-conditions`}>
        <RichText messageKey="current_terms_and_conditions" />
      </BodyLink>
    </div>
  );
};

export default CurrentTermsAndConditionsLink;
